import { Uploader } from "./upload_common";
import { S3Upload } from "./s3";

class FolderUploader extends Uploader {
    constructor(root) {
        super(root)

        const mappingElem = $("#folder_name_mapping")
        // Disable text selection for sortable elements
        mappingElem.css({
            '-webkit-user-select': 'none',
            '-moz-user-select': 'none',
            '-ms-user-select': 'none',
            'user-select': 'none'
        });

        let that = this
        // Native JavaScript sortable implementation
        this.makeSortable(mappingElem[0], () => {
            that.update_mapping(true)
        })
    }

    validateRow(target, files) {
        const container = target.closest('.uploader-container')
        const status = container.querySelector('.upload-status')

        this.folders = {}
        let folders = {}

        for (let file of files) {
            let path = file.fullPath.split('/')

            // deep folder
            while (path.length > 3) {
                path.shift()
            }
            if (path.length === 3 && path[1] !== 'extra views') {
                path.shift()
            }

            let folderName = path[0]
            let row = 'rotation'


            if (path.length === 2) {
                row = 'rotation'
            } else if (path.length === 3 && path[1] === 'extra views') {
                row = 'additional'
            } else {
                this.statusError(status, 'Please select only folders containing images or "extra views".')
                return
            }

            if (!this.isImage(file)) {
                this.statusError(status, "Invalid file type selected. Please select only folders containing images (.jpg, .jpeg, .png).")
                return
            }

            if (!(folderName in folders)) {
                let folder = {}
                folder.rotation = []
                folder.additional = []
                folder.progress = 0
                folder.size = 0
                folder.mapping = {}
                folders[folderName] = folder
            }

            let folder = folders[folderName]

            if (row === 'rotation') {
                folder.rotation.push(file)
            } else {
                folder.additional.push(file)
            }

            file.folderName = folderName
            folder.size += file.size
        }

        for (let folderName in folders) {
            let folder = folders[folderName]
            if (folder.rotation.length < 4 || folder.rotation.length > 360) {
                this.statusError(status, 'Please  select only folders containing between 4..360 images (.jpg, .jpeg, .png)')
                return
            }
        }


        this.folders = folders

        this.update_mapping()

        this.statusSuccess(status, `${files.length} files selected`)
        this.submitButton.removeAttribute('disabled')
    }

    update_mapping(uploadMapping = false) {
        let mapping = []

        const mappingElem = this.root.querySelector('#folder_name_mapping')
        const list = this.root.querySelector('#folder_upload_result')
        list.innerHTML = ''

        let tr = document.createElement('tr')
        list.appendChild(tr)

        for (let li of mappingElem.querySelectorAll('li')) {
            mapping.push(li.getAttribute('data-key'))
            let th = document.createElement('th')
            th.innerText = li.innerText
            tr.appendChild(th)
        }
        // files
        let th = document.createElement('th')
        th.innerText = 'Files'
        tr.appendChild(th)

        // Combined size/progress column
        th = document.createElement('th')
        th.innerText = 'Size'
        tr.appendChild(th)

        // upload mapping if it was changed
        if (uploadMapping === true && mapping.length === 4) {
            const url = mappingElem.getAttribute('data-url')
            $.post(url, {
                mapping
            })
        }

        if (!this.folders || Object.keys(this.folders).length === 0) {
            list.innerHTML = ''
            let tr = document.createElement('tr')
            let td = document.createElement('td')
            td.className = 'text-sm'
            td.innerText = 'No files selected'
            tr.appendChild(td)
            list.appendChild(tr)
            return
        }

        for (let folderName in this.folders) {
            let folder = this.folders[folderName]
            const values = folderName.split('.')

            let tr = document.createElement('tr')
            list.appendChild(tr)

            for (let i = 0; i < mapping.length; i++) {
                let key = mapping[i]
                let value = ''
                if (values.length > i) {
                    value = values[i]
                }

                let td = document.createElement('td')
                td.innerText = value
                tr.appendChild(td)

                folder.mapping[key] = value
            }

            let td = document.createElement('td')
            td.style.textAlign = 'right'
            td.innerText = folder.rotation.length + folder.additional.length
            tr.appendChild(td)

            // Combined size/progress cell
            td = document.createElement('td')
            td.style.textAlign = 'center'
            td.innerText = (Math.round(folder.size / 100000) / 10) + 'MB'
            tr.appendChild(td)
            folder.sizeElem = td
        }
    }


    doSubmit() {
        this.numUploaders = 0
        this.completeUploaders = 0

        for (let folderName in this.folders) {
            this.numUploaders++

            let folder = this.folders[folderName]
            // create variant for each folder
            const result = this.postVariant(folder.mapping)
            if (!result?.uuid) {
                this.submitted = false
                const message = (result?.errors && Object.values(result.errors).flat()[0]) || 'Upload failed. Please try again.'
                this.uploadFailed(message)
                return
            }
            const variant = result
            const uploader = new S3Upload(variant, this)
            uploader.enqueue("frames", 1, folder.rotation)
            uploader.enqueue("stills", 13, folder.additional)
            uploader.upload()
        }
    }


    uploadProgress(total, file, filePercent) {
        let folder = this.folders[file.folderName]

        folder.progress = total

        // Show progress instead of size when upload starts
        if (total > 0) {
            folder.sizeElem.innerText = total + '%'
        }

        let folders = Object.values(this.folders)
        let completed = folders.reduce((acc, cur) => acc + cur.progress, 0)
        completed = Math.round(completed / folders.length)
        super.uploadProgress(completed)
    }



    uploadComplete() {
        this.completeUploaders++
        console.log("upload complete " + this.completeUploaders)

        if (this.numUploaders === this.completeUploaders) {
            this.submitButton.innerHTML = `Upload complete`
            this.submitButton.style.background = '#218838'
            this.submitButton.innerText = 'Upload complete'
            let that = this
            window.setTimeout(() => {
                window.location = that.form.getAttribute('data-redirect')
            }, 1000)
        }
    }
}

function initializeFolderUploaders() {
    const root = document.querySelector('#folder_upload')
    if (root !== null && !root.dataset.uploaderInitialized) {
        new FolderUploader(root)
        root.dataset.uploaderInitialized = 'true'
    }
}

// Initialize on full page load (non-Turbo) and Turbo navigations
window.addEventListener('load', initializeFolderUploaders)
document.addEventListener('turbo:load', initializeFolderUploaders)
document.addEventListener('turbo:frame-load', initializeFolderUploaders)

// Make FolderUploader available globally for dynamic initialization
window.FolderUploader = FolderUploader;
